// Different badge variants
export enum BadgeKind {
  Default = "default", // regular badge
  Faded = "faded", // slightly lighter, used for unrated badges
  Disabled = "disabled" // grayed-out badge
}
